import React from 'react'

export default function ServiceManagementNoCode() {
  return (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.526 25.5205L10.5469 37.4997L22.526 49.4788" stroke="url(#paint0_linear_4471_7210)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M52.4736 25.5205L64.4528 37.4997L56.9658 44.9867" stroke="url(#paint1_linear_4471_7210)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M43.4891 13.542L39.8924 27.932M37.4906 37.5363L31.501 61.4587" stroke="url(#paint2_linear_4471_7210)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5469 10.5469L64.4531 64.4531" stroke="url(#paint3_linear_4471_7210)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_4471_7210" x1="16.5365" y1="25.5205" x2="16.5365" y2="49.4788" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint1_linear_4471_7210" x1="58.4632" y1="25.5205" x2="58.4632" y2="44.9867" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint2_linear_4471_7210" x1="37.4951" y1="13.542" x2="37.4951" y2="61.4587" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint3_linear_4471_7210" x1="37.5" y1="10.5469" x2="37.5" y2="64.4531" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
      </defs>
    </svg>
  )
}
